import React, { useState } from "react";
import { deleteAddCost } from "../../../api/OrderSummaryApi";
import { useQueryClient } from "react-query";
import useSessionState from "../../../hooks/useSessionState";
import { AddCostObj } from "../../../GlobalTypes";

function useAddCostsSelector(
  quoteId: string,
  disableChanges: boolean,
  margin: string,
  withMarkup: boolean,
  hasDealerTax: boolean,
  isFetching: boolean
) {
  const queryClient = useQueryClient();

  const [expandAddCost, setExpand] = useSessionState("expandAddCost", false);

  const [open, setOpen] = useState(false);

  const [cost, setCost] = useState<AddCostObj>({
    _id: "",
    title: "",
    price: 0,
    taxable: false,
  });

  const handleChange = (event: React.SyntheticEvent, expanded: boolean) =>
    setExpand(expanded);

  const handleOpen = (itm: AddCostObj) => {
    if (!itm._id) {
      itm.taxable && !hasDealerTax
        ? setCost({ ...itm, _id: "tax" })
        : setCost({ ...itm, _id: "notax" });
      return setOpen(true);
    }

    setCost(itm);
    setOpen(true);
  };

  const handleOpenNewCost = () => {
    if (disableChanges) return;
    setCost({
      _id: "",
      title: "",
      price: 0,
      taxable: false,
    });
    setOpen(true);
  };

  const handleClose = () => {
    setCost({
      _id: "",
      title: "",
      price: 0,
      taxable: false,
    });
    setOpen(false);
  };

  const deleteCost = async (cId: string | null, tax: boolean) => {
    if (isFetching || disableChanges) return;

    const id = cId ? cId : tax ? "tax" : "notax";

    const response = await deleteAddCost({
      quoteId,
      costId: id,
      margin,
      withMarkup,
    });

    if (response.data.matchedCount === 1) {
      queryClient.invalidateQueries("Cart");
    }
  };

  return {
    deleteCost,
    handleClose,
    handleOpenNewCost,
    handleOpen,
    handleChange,
    cost,
    open,
    expandAddCost,
  };
}

export default useAddCostsSelector;
